<template>
    <button
        type="button"
        class="ds-btn"
        :class="['ds-btn--' + variant, 'ds-btn--' + size]"
        :disabled="disabled"
        @click="$emit('click', $event)"
    >
        <ds-icon v-if="icon" :name="icon" :size="18" />
        <slot></slot>
        <ds-icon v-if="iconRight" :name="iconRight" :size="18" />
    </button>
</template>

<script>
export default {
    name: 'DsButton',
    props: {
        variant: { type: String, default: 'primary' },
        size: { type: String, default: 'md' },
        icon: { type: String, default: null },
        iconRight: { type: String, default: null },
        disabled: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.ds-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font: var(--type-button);
    border-radius: var(--radius-pill);
    border: var(--border-width) solid transparent;
    cursor: pointer;
    transition: var(--transition-control);
    white-space: nowrap;
}
.ds-btn:disabled {
    opacity: .5;
    cursor: default;
}
.ds-btn--md { height: var(--control-height); padding: 0 18px; }
.ds-btn--sm { height: var(--control-height-sm); padding: 0 14px; font-size: var(--text-sm); }

.ds-btn--primary { background: var(--action-primary); color: var(--text-on-accent); }
.ds-btn--primary:not(:disabled):hover { background: var(--action-primary-hover); }

.ds-btn--secondary { background: transparent; color: var(--action-secondary-fg); border-color: var(--action-secondary-border); }
.ds-btn--secondary:not(:disabled):hover { background: var(--info-soft); }

.ds-btn--quiet { background: transparent; color: var(--action-quiet-fg); }
.ds-btn--quiet:not(:disabled):hover { background: var(--surface-hover); }

.ds-btn--danger { background: var(--danger); color: var(--text-on-accent); }
.ds-btn--danger:not(:disabled):hover { background: #A81F1F; }
</style>
